import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import {
	CogIcon, ShieldCheckIcon, UsersIcon, CheckCircleIcon,
	MailIcon, PlusIcon, TrashIcon, SaveIcon,
	SparklesIcon, HomeIcon
} from '@heroicons/react/outline'
import Loader from '../UI/Loader'
import BannerInfo from '../UI/BannerInfo'
import LangSelector from '../UI/LangSelector'
import connexion from '../../connexion'

// Inline SVGs — icônes absentes de heroicons v1
const CarIcon = ({ className }) => (
	<svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
		<path strokeLinecap="round" strokeLinejoin="round" d="M9 17a2 2 0 11-4 0 2 2 0 014 0zm10 0a2 2 0 11-4 0 2 2 0 014 0zM3 12l2-6h14l2 6M3 12h18" />
	</svg>
)

const DogIcon = ({ className }) => (
	<svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
		<path strokeLinecap="round" strokeLinejoin="round" d="M12 4C9.8 4 8 5.8 8 8s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zM4 20c0-3.3 3.6-6 8-6s8 2.7 8 6" />
	</svg>
)

const WavesIcon = ({ className }) => (
	<svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
		<path strokeLinecap="round" strokeLinejoin="round" d="M3 10c1.5 0 2.5-1 4-1s2.5 1 4 1 2.5-1 4-1 2.5 1 4 1M3 15c1.5 0 2.5-1 4-1s2.5 1 4 1 2.5-1 4-1 2.5 1 4 1" />
	</svg>
)

const BedIcon = ({ className }) => (
	<svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
		<path strokeLinecap="round" strokeLinejoin="round" d="M3 12V8a1 1 0 011-1h16a1 1 0 011 1v4M3 12h18M3 12v5h18v-5" />
	</svg>
)

const ClockIcon = ({ className }) => (
	<svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
		<path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
	</svg>
)

const DEFAULT_VALUES = {
	activate: true,
	participants: true,
	animals: true,
	vehicles: true,
	jacuzzi: false,
	kits: false,
	emails: [{ offset: 7, unit: 'days' }],
	mandatory: {
		place_of_birth: false,
		identity_card: false,
		vehicle_brand: false,
		vehicle_color: false,
		animal_weight: false,
		animal_name: false,
		animal_chip: false,
		animal_last_vaccine: false
	},
	naxi_kit_simple: '',
	naxi_kit_double: '',
	naxi_baby_beds: '',
	naxi_baby_chairs: '',
	naxi_kit_towels: '',
	pms_check: false,
	checkout_time: '',
	checkin_time: '',
	checkout_warning: [],
	checkin_warning: [],
	emplacement_checkout_warning: [],
	emplacement_checkin_warning: [],
	checkout_warning_enabled: false,
	checkin_warning_enabled: false,
	late_arrival_check: false,
	late_arrival_warning: [],
	block_arrival_time: '',
	block_arrival_time_check: false
}

class CheckinsParam extends Component
{
	constructor(props)
	{
		super(props)
		this.state = {
			config_checkins: null,
			config_pms: null,
			attempt_submit: false,
			form1: { ...DEFAULT_VALUES, mandatory: { ...DEFAULT_VALUES.mandatory } },
			banner_content: null,
			show_banner: false,
			active_tab: 'general',
			current_lang: props.lang_default || 'fr',
			stay_hours: null
		}
		this.pages = [
			{ name: 'Arrivées', href: '/checkins/arrivals', current: false }
		]
	}

	componentDidMount()
	{
		this.loadConfigCheckins()
		this.loadConfigPms()
		fetch(connexion.connect.url + 'dashboard/config/stay-hours')
			.then(res => res.json())
			.then(value => {
				if (value)
					this.setState({ stay_hours: value })
			})
			.catch(() => {})
	}

	componentDidUpdate(prevProps)
	{
		if (prevProps.config_checkins !== this.props.config_checkins)
			this.loadConfigCheckins(true)
		if (prevProps.config_pms !== this.props.config_pms)
			this.loadConfigPms(true)
	}

	loadConfigPms = (fromProps = false) => {
		const _apply = (cfg) => {
			const pms_check = !!(cfg && cfg.values && cfg.values.pms_check)
			this.setState(prev => ({
				config_pms: cfg,
				form1: { ...prev.form1, pms_check }
			}))
		}
		if (fromProps === true)
		{
			_apply(this.props.config_pms)
		}
		else if (this.props.config_pms)
		{
			_apply(this.props.config_pms)
		}
		else if (this.props.fetchConfigPms)
		{
			this.props.fetchConfigPms()
			.then(cfg => _apply(cfg))
			.catch(() => {})
		}
	}

	loadConfigCheckins = (fromProps = false) => {
		if (fromProps === true)
		{
			const cfg = this.props.config_checkins
			this.setState(prev => ({ config_checkins: cfg, form1: { ...this._formFromConfig(cfg), pms_check: prev.form1.pms_check } }))
		}
		else
		{
			this.props.fetchConfigCheckins()
			.then(cfg => {
				this.setState(prev => ({ config_checkins: cfg, form1: { ...this._formFromConfig(cfg), pms_check: prev.form1.pms_check } }))
			})
			.catch(err => {
				this.setErrorMsg("error_fetch_config", 1)
				console.log(err)
			})
		}
	}

	_formFromConfig = (cfg) => {
		if (!cfg)
			return { ...DEFAULT_VALUES, mandatory: { ...DEFAULT_VALUES.mandatory } }
		const mandatory = cfg.mandatory || {}
		return {
			activate: cfg.activate !== false,
			participants: cfg.participants !== false,
			animals: cfg.animals !== false,
			vehicles: cfg.vehicles !== false,
			jacuzzi: !!cfg.jacuzzi,
			kits: !!cfg.kits,
			emails: (cfg.emails && cfg.emails.length > 0)
				? cfg.emails.map(e => ({ offset: e.offset || 7, unit: e.unit || 'days' }))
				: [{ offset: 7, unit: 'days' }],
			mandatory: {
				place_of_birth: !!mandatory.place_of_birth,
				identity_card: !!mandatory.identity_card,
				vehicle_brand: !!mandatory.vehicle_brand,
				vehicle_color: !!mandatory.vehicle_color,
				animal_weight: !!mandatory.animal_weight,
				animal_name: !!mandatory.animal_name,
				animal_chip: !!mandatory.animal_chip,
				animal_last_vaccine: !!mandatory.animal_last_vaccine
			},
			naxi_kit_simple: cfg.kits_spl || '',
			naxi_kit_double: cfg.kits_dbl || '',
			naxi_baby_beds: cfg.baby_beds || '',
			naxi_baby_chairs: cfg.baby_chairs || '',
			naxi_kit_towels: cfg.kit_towels || '',
			checkout_time: cfg.departure_time_hour != null ? cfg.departure_time_hour : '',
			checkin_time: cfg.arrival_time_hour != null ? cfg.arrival_time_hour : '',
			checkout_warning: Array.isArray(cfg.departure_time_str) ? cfg.departure_time_str : [],
			checkin_warning: Array.isArray(cfg.arrival_time_str) ? cfg.arrival_time_str : [],
			emplacement_checkout_warning: Array.isArray(cfg.emplacement_departure_time_str) ? cfg.emplacement_departure_time_str : [],
			emplacement_checkin_warning: Array.isArray(cfg.emplacement_arrival_time_str) ? cfg.emplacement_arrival_time_str : [],
			checkout_warning_enabled: !!cfg.departure_hour_check,
			checkin_warning_enabled: !!cfg.arrival_time_check,
			late_arrival_check: !!cfg.late_arrival_check,
			late_arrival_warning: Array.isArray(cfg.late_arrival_str) ? cfg.late_arrival_str : [],
			block_arrival_time: cfg.block_arrival_time_hour != null ? cfg.block_arrival_time_hour : '',
			block_arrival_time_check: !!cfg.block_arrival_time_check
		}
	}

	setErrorMsg = (key, msg) => {
		let content
		if (key === "error_fetch_config")
			content = "Impossible de récupérer les paramètres check-ins (" + msg + ")"
		else if (key === "error_update_config")
			content = "Impossible de mettre à jour les paramètres check-ins (" + msg + ")"
		else
			content = "Erreur inattendue"
		this.setState({ show_banner: true, banner_content: content })
	}

	closeBanner = () => {
		this.setState({ show_banner: false })
	}

	_toggle = (field) => {
		const form1 = { ...this.state.form1, [field]: !this.state.form1[field] }
		this.setState({ form1 })
	}

	_toggleMandatory = (field) => {
		const mandatory = { ...this.state.form1.mandatory, [field]: !this.state.form1.mandatory[field] }
		this.setState({ form1: { ...this.state.form1, mandatory } })
	}

	_addEmail = () => {
		if (this.state.form1.emails.length >= 10)
			return
		const emails = [...this.state.form1.emails, { offset: 7, unit: 'days' }]
		this.setState({ form1: { ...this.state.form1, emails } })
	}

	_removeEmail = (index) => {
		if (this.state.form1.emails.length <= 1)
			return
		const emails = this.state.form1.emails.filter((_, i) => i !== index)
		this.setState({ form1: { ...this.state.form1, emails } })
	}

	_updateEmail = (index, field, value) => {
		const emails = this.state.form1.emails.map((e, i) => i === index ? { ...e, [field]: value } : e)
		this.setState({ form1: { ...this.state.form1, emails } })
	}

	submitConfig = () => {
		this.setState({ attempt_submit: true })
		const config = {
			activate: this.state.form1.activate,
			participants: this.state.form1.participants,
			animals: this.state.form1.animals,
			vehicles: this.state.form1.vehicles,
			jacuzzi: this.state.form1.jacuzzi,
			kits: this.state.form1.kits,
			emails: this.state.form1.emails.map(e => ({ offset: parseInt(e.offset, 10) || 1, unit: e.unit })),
			mandatory: { ...this.state.form1.mandatory },
			kits_spl: this.state.form1.naxi_kit_simple || null,
			kits_dbl: this.state.form1.naxi_kit_double || null,
			baby_beds: this.state.form1.naxi_baby_beds || null,
			baby_chairs: this.state.form1.naxi_baby_chairs || null,
			kit_towels: this.state.form1.naxi_kit_towels || null,
			departure_time_hour: this.state.form1.checkout_time !== '' ? parseInt(this.state.form1.checkout_time, 10) : null,
			arrival_time_hour: this.state.form1.checkin_time !== '' ? parseInt(this.state.form1.checkin_time, 10) : null,
			departure_time_str: this.state.form1.checkout_warning.length > 0 ? this.state.form1.checkout_warning : null,
			arrival_time_str: this.state.form1.checkin_warning.length > 0 ? this.state.form1.checkin_warning : null,
			emplacement_departure_time_str: this.state.form1.emplacement_checkout_warning.length > 0 ? this.state.form1.emplacement_checkout_warning : null,
			emplacement_arrival_time_str: this.state.form1.emplacement_checkin_warning.length > 0 ? this.state.form1.emplacement_checkin_warning : null,
			departure_hour_check: this.state.form1.checkout_warning_enabled,
			arrival_time_check: this.state.form1.checkin_warning_enabled,
			late_arrival_check: this.state.form1.late_arrival_check,
			late_arrival_str: this.state.form1.late_arrival_warning.length > 0 ? this.state.form1.late_arrival_warning : null,
			block_arrival_time_hour: this.state.form1.block_arrival_time !== '' ? parseInt(this.state.form1.block_arrival_time, 10) : null,
			block_arrival_time_check: this.state.form1.block_arrival_time_check
		}
		const checkins_promise = this.props.updateConfigCheckins(config)
		const pms_promise = this.props.updateConfigPms
			? this.props.updateConfigPms({ pms_check: this.state.form1.pms_check })
			: Promise.resolve(true)
		Promise.all([checkins_promise, pms_promise])
		.then(([ret]) => {
			if (ret !== false)
				this.setState({ attempt_submit: false, show_banner: true, banner_content: "Les paramètres ont bien été mis à jour" })
			else
			{
				this.setState({ attempt_submit: false })
				this.setErrorMsg("error_update_config", 1)
			}
		})
		.catch(err => {
			console.log(err)
			this.setState({ attempt_submit: false })
			this.setErrorMsg("error_update_config", 2)
		})
	}

	updateLang = (lang) => {
		this.setState({ current_lang: lang })
	}

	_getTranslationText = (translations, lang) => {
		if (!Array.isArray(translations))
			return ''
		const entry = translations.find(t => t.lang === lang)
		return entry ? entry.text : ''
	}

	_setTranslationText = (translations, lang, value) => {
		const arr = Array.isArray(translations) ? [...translations] : []
		const idx = arr.findIndex(t => t.lang === lang)
		if (idx >= 0)
			arr[idx] = { lang, text: value }
		else
			arr.push({ lang, text: value })
		return arr
	}

	_renderToggle = (label, description, iconElement, enabled, onToggle, disabled = false) => {
		return (
			<div
				onClick={disabled ? null : onToggle}
				className={`flex items-start justify-between p-4 rounded-2xl border border-transparent transition-all ${disabled ? 'opacity-40 cursor-not-allowed' : 'hover:bg-slate-50 cursor-pointer'}`}
			>
				<div className="flex gap-4">
					{iconElement && (
						<div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-all ${enabled && !disabled ? 'bg-indigo-50 text-indigo-600' : 'bg-slate-100 text-slate-400'}`}>
							{iconElement}
						</div>
					)}
					<div className="flex flex-col justify-center">
						<span className="text-sm font-bold text-slate-900">{label}</span>
						{description && <span className="text-[11px] text-slate-500 font-medium mt-0.5">{description}</span>}
					</div>
				</div>
				<div className={`w-12 h-6 rounded-full relative flex-shrink-0 ml-4 mt-1 transition-all duration-300 ${enabled && !disabled ? 'bg-indigo-500' : 'bg-slate-200'}`}>
					<div className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow-sm transition-all duration-300 ${enabled && !disabled ? 'left-7' : 'left-1'}`} />
				</div>
			</div>
		)
	}

	render()
	{
		const { form1, attempt_submit, active_tab, config_pms, current_lang } = this.state
		const activate_disabled = !form1.activate
		const is_inaxel = !!(config_pms && config_pms.values && config_pms.values.name === 'inaxel')

		const tabs = [
			{ id: 'general', label: 'Général',              icon: <CogIcon className="h-5 w-5" /> },
			{ id: 'fields',  label: 'Champs obligatoires',  icon: <CheckCircleIcon className="h-5 w-5" /> },
			{ id: 'emails',  label: 'Relances email',       icon: <MailIcon className="h-5 w-5" /> },
			{ id: 'options', label: 'Options supp.',        icon: <SparklesIcon className="h-5 w-5" /> },
		]

		const save_btn = attempt_submit
			? <div className="px-6 py-3"><Loader /></div>
			: (
				<button
					onClick={this.submitConfig}
					className="px-6 py-3 bg-indigo-600 rounded-2xl text-sm font-bold text-white flex items-center gap-2 shadow-sm hover:bg-indigo-700 transition-colors"
					style={{ backgroundImage: 'none', backgroundColor: '#4f46e5' }}
				>
					<SaveIcon className="h-4 w-4" />
					<span>Enregistrer les modifications</span>
				</button>
			)

		return (
			<>
				<BannerInfo
					content={this.state.banner_content}
					show={this.state.show_banner}
					closeBanner={this.closeBanner}
				/>

				{/* Breadcrumb */}
				<div className="mb-5" aria-label="Breadcrumb">
					<ol className="flex items-center gap-1 text-sm">
						<li className="flex items-center">
							<Link to="/" className="text-gray-400 hover:text-gray-600 transition-colors">
								<HomeIcon className="flex-shrink-0 h-4 w-4" aria-hidden="true" />
								<span className="sr-only">Accueil</span>
							</Link>
						</li>
						<li className="flex items-center">
							<span className="text-gray-300 mx-1 select-none">/</span>
							<Link to="/checkins/arrivals" className="text-gray-400 hover:text-gray-600 transition-colors">Arrivées</Link>
						</li>
						<li className="flex items-center">
							<span className="text-gray-300 mx-1 select-none">/</span>
							<span className="text-gray-500">Paramètres</span>
						</li>
					</ol>
				</div>
				{/* Header */}
				<div className="flex items-end justify-between mb-8">
					<div>
						<h1 style={{ fontFamily: "'Fraunces', Georgia, serif", letterSpacing: '-0.02em' }} className="text-4xl font-bold text-gray-900 leading-none mt-0 mb-0">
							Réglages des pré-checkins
						</h1>
						<p className="text-sm text-gray-400 mt-2 mb-0">Gérez les paramètres de vos pré-checkins</p>
					</div>
					{save_btn}
				</div>

				<div className="grid grid-cols-12 gap-8">
					{/* Sidebar tabs */}
					<div className="col-span-3 flex flex-col gap-2">
						{tabs.map(tab => (
							<button
								key={tab.id}
								onClick={() => this.setState({ active_tab: tab.id })}
								className={`flex items-center gap-3 px-5 py-4 rounded-3xl text-sm font-bold transition-all text-left ${active_tab === tab.id ? 'bg-white border border-slate-200 shadow-sm text-indigo-600' : 'text-slate-400 hover:text-slate-600 hover:bg-white/50'}`}
								style={{ backgroundImage: 'none', backgroundColor: active_tab === tab.id ? '#ffffff' : 'transparent' }}
							>
								{tab.icon}
								<span>{tab.label}</span>
								{active_tab === tab.id && (
									<div className="ml-auto w-1.5 h-1.5 rounded-full bg-indigo-500 flex-shrink-0" />
								)}
							</button>
						))}
					</div>

					{/* Content panel — key forces re-animation on tab change */}
					<div className="col-span-9">
						<motion.div
							key={active_tab}
							initial={{ opacity: 0, x: 16 }}
							animate={{ opacity: 1, x: 0 }}
							transition={{ duration: 0.18 }}
						>
							{/* GÉNÉRAL */}
							{active_tab === 'general' && (
								<div className="flex flex-col gap-6">
									<div className="bg-white rounded-3xl border border-slate-200 shadow-sm p-8">
										<div className="flex items-center gap-4 mb-6">
											<div className="p-2.5 bg-white border border-slate-100 rounded-2xl shadow-sm text-slate-600">
												<ShieldCheckIcon className="h-5 w-5" />
											</div>
											<div>
												<h3 className="text-lg font-black text-slate-900 tracking-tight leading-tight">Sections de l'application</h3>
												<p className="text-xs text-slate-500 font-medium">Activez ou désactivez les fonctionnalités affichées dans l'espace client</p>
											</div>
										</div>
										<div className="flex flex-col gap-1">
											{this._renderToggle(
												"Activation des pré-checkins",
												"Activer ou désactiver globalement la fonctionnalité de pré-checkin",
												<ShieldCheckIcon className="h-5 w-5" />,
												form1.activate,
												() => this._toggle('activate')
											)}
											{this._renderToggle(
												"Gestion des véhicules",
												"Permettre aux clients de déclarer leurs véhicules avant l'arrivée",
												<CarIcon className="h-5 w-5" />,
												form1.vehicles,
												() => this._toggle('vehicles'),
												activate_disabled
											)}
											{this._renderToggle(
												"Gestion des animaux",
												"Afficher la section de déclaration des animaux de compagnie",
												<DogIcon className="h-5 w-5" />,
												form1.animals,
												() => this._toggle('animals'),
												activate_disabled
											)}
											{this._renderToggle(
												"Gestion des accompagnants",
												"Afficher la section des participants additionnels",
												<UsersIcon className="h-5 w-5" />,
												form1.participants,
												() => this._toggle('participants'),
												activate_disabled
											)}
										</div>
									</div>
									<div className={`bg-white rounded-3xl border border-slate-200 shadow-sm p-8 ${activate_disabled ? 'opacity-50 pointer-events-none' : ''}`}>
										<div className="flex items-center gap-4 mb-6">
											<div className="p-2.5 bg-white border border-slate-100 rounded-2xl shadow-sm text-slate-600">
												<ClockIcon className="h-5 w-5" />
											</div>
											<div>
												<h3 className="text-lg font-black text-slate-900 tracking-tight leading-tight">Horaires d'arrivées</h3>
												<p className="text-xs text-slate-500 font-medium">Avertissements affichés au campeur selon l'heure d'arrivée choisie</p>
											</div>
										</div>
										<div className="flex flex-col gap-3">
											<div className="px-4 py-1">
												<Link
													to="/administration/parametres"
													className="inline-flex items-center gap-2 px-4 py-2.5 rounded-2xl bg-white border border-slate-200 hover:border-indigo-300 text-sm font-bold text-slate-700 hover:text-indigo-700 transition-all"
												>
													<ClockIcon className="w-4 h-4 flex-shrink-0" />
													Modifier les horaires d'arrivée et de départ →
												</Link>
											</div>
											<div className="px-4 pt-2 pb-1">
												<LangSelector lang={current_lang} updateLang={this.updateLang} />
											</div>
											{(() => {
												// Bornes réelles (paramètres généraux) pour des libellés concrets
												const sh = this.state.stay_hours || {}
												const loc = sh.locatif || {}
												const emp = sh.emplacement || {}
												const empDep = emp.departure != null ? emp.departure : loc.departure
												const empArr = emp.arrival != null ? emp.arrival : loc.arrival
												const h = (v) => (v != null ? v + 'h' : '—')
												const toggle = (key) => (
													<div onClick={() => this.setState({ form1: { ...form1, [key]: !form1[key] } })} className="cursor-pointer flex-shrink-0">
														<div className={`w-12 h-6 rounded-full relative transition-all duration-300 ${form1[key] ? 'bg-indigo-500' : 'bg-slate-200'}`}>
															<div className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow-sm transition-all duration-300 ${form1[key] ? 'left-7' : 'left-1'}`} />
														</div>
													</div>
												)
												const msgField = (key, label, example) => (
													<div className="space-y-1">
														<span className="text-xs font-bold text-slate-600 block">{label}</span>
														<textarea
															rows={2}
															value={this._getTranslationText(form1[key], current_lang)}
															onChange={e => this.setState({ form1: { ...form1, [key]: this._setTranslationText(form1[key], current_lang, e.target.value) } })}
															placeholder={example}
															className="browser-default w-full px-4 py-2.5 bg-white border border-slate-200 rounded-2xl text-sm font-medium text-slate-700 focus:outline-none focus:border-indigo-400 transition-all resize-none"
															style={{ boxSizing: 'border-box', height: 'auto' }}
														/>
													</div>
												)
												const windowBlock = (opts) => (
													<div className="mx-4 rounded-2xl border border-slate-200 overflow-hidden">
														<div className="flex items-start justify-between gap-4 p-4 bg-white">
															<div>
																<p className="text-sm font-bold text-slate-900 my-0">{opts.title}</p>
																<p className="text-xs text-slate-500 font-medium my-0 mt-1">{opts.subtitle}</p>
															</div>
															{toggle(opts.toggle_key)}
														</div>
														{form1[opts.toggle_key] && (
															<div className="border-t border-slate-100 p-4 space-y-3" style={{ backgroundColor: '#f8fafc' }}>
																{opts.fields}
																<p className="text-xs text-slate-400 font-medium my-0">
																	<span role="img" aria-label="astuce">💡</span> <span className="font-bold">{'{heure}'}</span> est remplacé automatiquement par l'horaire du type d'hébergement du vacancier.
																</p>
															</div>
														)}
													</div>
												)
												return (
													<div className="flex flex-col gap-3">
														{windowBlock({
															toggle_key: 'checkout_warning_enabled',
															title: `1. Arrivée pendant que les hébergements se libèrent (avant ${h(loc.departure)} en locatif · ${h(empDep)} en emplacement)`,
															subtitle: "Les occupants précédents ne sont peut-être pas encore partis : c'est le message le plus prudent.",
															fields: (
																<>
																	{msgField('checkout_warning', 'Message pour les hébergements locatifs',
																		"Ex. : Les départs se font jusqu'à {heure} — votre hébergement ne sera peut-être pas encore libéré à votre arrivée.")}
																	{msgField('emplacement_checkout_warning', 'Message pour les emplacements nus (vide = même message que les locatifs)',
																		"Ex. : Les emplacements se libèrent jusqu'à {heure} — le vôtre ne sera peut-être pas encore disponible.")}
																</>
															)
														})}
														{windowBlock({
															toggle_key: 'checkin_warning_enabled',
															title: `2. Arrivée pendant la préparation (jusqu'à ${h(loc.arrival)} en locatif · ${h(empArr)} en emplacement)`,
															subtitle: "L'hébergement est libéré mais les équipes le préparent : message rassurant.",
															fields: (
																<>
																	{msgField('checkin_warning', 'Message pour les hébergements locatifs',
																		"Ex. : Les arrivées se font à partir de {heure} — nos équipes feront le maximum pour que tout soit prêt. Profitez du camping en attendant !")}
																	{msgField('emplacement_checkin_warning', 'Message pour les emplacements nus (vide = même message que les locatifs)',
																		"Ex. : Votre emplacement sera disponible à partir de {heure} — profitez des installations en attendant.")}
																</>
															)
														})}
														{windowBlock({
															toggle_key: 'late_arrival_check',
															title: `3. Arrivée tardive (à partir de ${h(sh.late_arrival)})`,
															subtitle: "L'accueil sera peut-être fermé : invitez le vacancier à prévenir pour organiser la remise des clés, les codes d'accès, où se garer…",
															fields: (
																<>
																	{msgField('late_arrival_warning', "Message (tous types d'hébergement)",
																		"Ex. : Arrivée après {heure} : pensez à prévenir l'accueil, qui vous transmettra les informations utiles avant votre arrivée (remise des clés, codes d'accès, où vous garer…).")}
																</>
															)
														})}
													</div>
												)
											})()}
											<div className="flex items-center justify-between gap-4 px-4 py-1 pt-2 border-t border-slate-100">
												<span className="text-sm font-bold text-slate-900 shrink-0">Bloquer les arrivées avant une heure fixe</span>
												<div className="flex items-center gap-3">
													<input
														type="number"
														min="0"
														max="23"
														value={form1.block_arrival_time}
														onChange={e => {
															const v = e.target.value
															if (v === '' || (Number.isInteger(+v) && +v >= 0 && +v <= 23))
																this.setState({ form1: { ...form1, block_arrival_time: v } })
														}}
														className="browser-default w-24 px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-medium text-slate-700 text-right focus:outline-none focus:border-indigo-400 focus:bg-white transition-all"
														placeholder="hh"
													/>
													<div onClick={() => this.setState({ form1: { ...form1, block_arrival_time_check: !form1.block_arrival_time_check } })} className="cursor-pointer flex-shrink-0">
														<div className={`w-12 h-6 rounded-full relative transition-all duration-300 ${form1.block_arrival_time_check ? 'bg-indigo-500' : 'bg-slate-200'}`}>
															<div className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow-sm transition-all duration-300 ${form1.block_arrival_time_check ? 'left-7' : 'left-1'}`} />
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							)}

							{/* CHAMPS OBLIGATOIRES */}
							{active_tab === 'fields' && (
								<div className={`bg-white rounded-3xl border border-slate-200 shadow-sm p-8 ${activate_disabled ? 'opacity-50 pointer-events-none' : ''}`}>
									<div className="flex items-center gap-4 mb-6">
										<div className="p-2.5 bg-white border border-slate-100 rounded-2xl shadow-sm text-slate-600">
											<CheckCircleIcon className="h-5 w-5" />
										</div>
										<div>
											<h3 className="text-lg font-black text-slate-900 tracking-tight leading-tight">Champs obligatoires</h3>
											<p className="text-xs text-slate-500 font-medium">Définissez les informations que les clients doivent impérativement renseigner</p>
										</div>
									</div>
									<div className="flex flex-col gap-8">
										<div>
											<span className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-3 block px-4">Fiche client</span>
											<div className="grid grid-cols-1 md:grid-cols-2 gap-1">
												{this._renderToggle("Lieu de naissance", null, null, form1.mandatory.place_of_birth, () => this._toggleMandatory('place_of_birth'))}
												{this._renderToggle("Numéro de pièce d'identité", null, null, form1.mandatory.identity_card, () => this._toggleMandatory('identity_card'))}
											</div>
										</div>
										<div className="pt-2 border-t border-slate-100">
											<span className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-3 block px-4">Véhicules</span>
											<div className="grid grid-cols-1 md:grid-cols-2 gap-1">
												{this._renderToggle("Marque du véhicule", null, null, form1.mandatory.vehicle_brand, () => this._toggleMandatory('vehicle_brand'))}
												{this._renderToggle("Couleur du véhicule", null, null, form1.mandatory.vehicle_color, () => this._toggleMandatory('vehicle_color'))}
											</div>
										</div>
										<div className="pt-2 border-t border-slate-100">
											<span className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-3 block px-4">Animaux</span>
											<div className="grid grid-cols-1 md:grid-cols-2 gap-1">
												{this._renderToggle("Poids de l'animal", null, null, form1.mandatory.animal_weight, () => this._toggleMandatory('animal_weight'))}
												{this._renderToggle("Nom de l'animal", null, null, form1.mandatory.animal_name, () => this._toggleMandatory('animal_name'))}
												{this._renderToggle("Puce d'identification", null, null, form1.mandatory.animal_chip, () => this._toggleMandatory('animal_chip'))}
												{this._renderToggle("Dernier vaccin", null, null, form1.mandatory.animal_last_vaccine, () => this._toggleMandatory('animal_last_vaccine'))}
											</div>
										</div>
									</div>
								</div>
							)}

							{/* RELANCES EMAIL */}
							{active_tab === 'emails' && (
								<div className={`bg-white rounded-3xl border border-slate-200 shadow-sm p-8 ${activate_disabled ? 'opacity-50 pointer-events-none' : ''}`}>
									<div className="flex items-center gap-4 mb-6">
										<div className="p-2.5 bg-white border border-slate-100 rounded-2xl shadow-sm text-slate-600">
											<MailIcon className="h-5 w-5" />
										</div>
										<div>
											<h3 className="text-lg font-black text-slate-900 tracking-tight leading-tight">Relances email</h3>
											<p className="text-xs text-slate-500 font-medium">Automatisez l'envoi d'emails de rappel pour maximiser vos taux de pré-checkin</p>
										</div>
									</div>
									<div className="flex flex-col gap-4">
										{form1.emails.map((email, index) => (
											<div key={index} className="flex items-center gap-4 group">
												<div className="w-12 h-12 rounded-2xl bg-indigo-50 border border-indigo-100 flex items-center justify-center text-indigo-600 font-black text-sm flex-shrink-0">
													#{index + 1}
												</div>
												<div className="flex-1 flex gap-3">
													<input
														type="number"
														value={email.offset}
														onChange={e => this._updateEmail(index, 'offset', e.target.value === '' ? '' : parseInt(e.target.value, 10))}
														className="browser-default w-24 px-4 py-3 bg-slate-50 focus:bg-white border border-slate-200 rounded-2xl text-sm font-bold focus:outline-none focus:border-indigo-400 transition-all"
													/>
													<select
														value={email.unit}
														onChange={e => this._updateEmail(index, 'unit', e.target.value)}
														className="browser-default flex-1 px-4 py-3 bg-slate-50 focus:bg-white border border-slate-200 rounded-2xl text-sm font-bold focus:outline-none focus:border-indigo-400 transition-all"
													>
														<option value="hours">heures avant le séjour</option>
														<option value="days">jours avant le séjour</option>
														<option value="weeks">semaines avant le séjour</option>
														<option value="months">mois avant le séjour</option>
													</select>
												</div>
												{form1.emails.length > 1 && (
													<button
														type="button"
														onClick={() => this._removeEmail(index)}
														className="p-3 text-slate-300 hover:text-rose-500 hover:bg-rose-50 rounded-2xl transition-all opacity-0 group-hover:opacity-100"
														style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
													>
														<TrashIcon className="h-5 w-5" />
													</button>
												)}
											</div>
										))}
										{form1.emails.length < 10 && (
											<button
												type="button"
												onClick={this._addEmail}
												className="w-full flex items-center justify-center gap-2 py-4 border-2 border-dashed border-slate-200 hover:border-indigo-300 hover:bg-indigo-50/30 rounded-3xl text-sm font-bold text-slate-400 hover:text-indigo-500 transition-all"
												style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
											>
												<PlusIcon className="h-5 w-5" />
												<span>Ajouter une relance programmée</span>
											</button>
										)}
									</div>
								</div>
							)}

							{/* OPTIONS SUPPLÉMENTAIRES */}
							{active_tab === 'options' && (
								<div className="flex flex-col gap-6">
									<div className={`bg-white rounded-3xl border border-slate-200 shadow-sm p-8 ${activate_disabled ? 'opacity-50 pointer-events-none' : ''}`}>
										<div className="flex items-center gap-4 mb-6">
											<div className="p-2.5 bg-white border border-slate-100 rounded-2xl shadow-sm text-slate-600">
												<SparklesIcon className="h-5 w-5" />
											</div>
											<div>
												<h3 className="text-lg font-black text-slate-900 tracking-tight leading-tight">Services & Options</h3>
												<p className="text-xs text-slate-500 font-medium">Gérez les options de confort et services additionnels proposés lors du parcours</p>
											</div>
										</div>
										<div className="flex flex-col gap-1">
											{this._renderToggle(
												"Option Jacuzzi",
												"Afficher la section permettant de réserver l'option Jacuzzi si disponible",
												<WavesIcon className="h-5 w-5" />,
												form1.jacuzzi,
												() => this._toggle('jacuzzi'),
												activate_disabled
											)}
											{this._renderToggle(
												"Location de draps et kits",
												"Proposer la location de kits de literie et accessoires bébé",
												<BedIcon className="h-5 w-5" />,
												form1.kits,
												() => this._toggle('kits'),
												activate_disabled
											)}
											{this._renderToggle(
												"Traitement PMS",
												"Afficher la colonne de suivi du traitement PMS dans le tableau des arrivées",
												null,
												form1.pms_check,
												() => this._toggle('pms_check')
											)}
										</div>
									</div>
									{is_inaxel && (
										<div className={`bg-white rounded-3xl border border-slate-200 shadow-sm p-8 ${activate_disabled ? 'opacity-50 pointer-events-none' : ''}`}>
											<div className="flex items-center gap-4 mb-6">
												<div className="p-2.5 bg-white border border-slate-100 rounded-2xl shadow-sm text-slate-600">
													<BedIcon className="h-5 w-5" />
												</div>
												<div>
													<h3 className="text-lg font-black text-slate-900 tracking-tight leading-tight">Import Inaxel</h3>
													<p className="text-xs text-slate-500 font-medium">Noms de colonnes utilisés dans l'export Inaxel pour l'import des kits</p>
												</div>
											</div>
											<div className="flex flex-col gap-3">
												{[
													{ key: 'naxi_kit_simple',  label: 'Kits draps simples' },
													{ key: 'naxi_kit_double',  label: 'Kits draps doubles' },
													{ key: 'naxi_baby_beds',   label: 'Lits bébés' },
													{ key: 'naxi_baby_chairs', label: 'Chaises bébés' },
													{ key: 'naxi_kit_towels',  label: 'Kits serviettes' }
												].map(({ key, label }) => (
													<div key={key} className="flex items-center justify-between gap-4 px-4 py-1">
														<span className="text-sm font-bold text-slate-900 shrink-0">{label}</span>
														<input
															type="text"
															value={form1[key]}
															onChange={e => this.setState({ form1: { ...form1, [key]: e.target.value } })}
															className="browser-default w-64 px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-medium text-slate-700 focus:outline-none focus:border-indigo-400 focus:bg-white transition-all"
															placeholder="Nom de colonne Inaxel"
														/>
													</div>
												))}
											</div>
										</div>
									)}
								</div>
							)}
						</motion.div>
					</div>
				</div>
			</>
		)
	}
}

export default CheckinsParam
